import React from 'react';
import { Box } from '@mui/material';
import { BulkSendMoneyListWithWalletNoDto } from '../../../types/approval.types';
import BulkApprovalModal from '../../../components/BulkApprovalModal';

interface BulkSendMoneyTransactionDetailProps {
  data: BulkSendMoneyListWithWalletNoDto;
}

const BulkSendMoneyTransactionDetail: React.FC<BulkSendMoneyTransactionDetailProps> = ({ data }) => {
  const transactionData = data?.Data ?? (data as any)?.data ?? [];

  return (
    <Box>
      <BulkApprovalModal
        data={{
          transactionData,
          transactionType: 'BulkSendMoneyListWithWalletNoDto',
          showActionButtons: false, // Don't show action buttons in detail view
        }}
      />
    </Box>
  );
};

export default BulkSendMoneyTransactionDetail;
